import { memo, useMemo, useState } from 'react'
import { useFormContext } from 'react-hook-form'

import { useFetchDepartments } from '../../api/apiHooks'
import { SearchableInput } from '../SearchableInput'
import { Inputs } from './GenerateMentorForm/GenerateMentorForm'

interface IDepartmentSelectProps {
  defaultValue?: string
  disabled?: boolean
}
type DepartmentPage = { items: string[] }

const DepartmentSelect: React.FC<IDepartmentSelectProps> = memo(
  ({ disabled, defaultValue }) => {
    const { setValue } = useFormContext<Inputs>()
    const [searchDepartment, setSearchDepartment] = useState<string>('')
    const { data, isFetching, hasNextPage, isFetchingNextPage, fetchNextPage } =
      useFetchDepartments(searchDepartment, !disabled)

    const handleSearchChange = (query: string) => {
      setSearchDepartment(query)
      if (query.trim()) {
        setValue('department', query)
      }
    }

    const searchResult = useMemo(
      (): string[] =>
        data?.pages.map((page: DepartmentPage) => page.items).flat() || [],
      [data],
    )

    const onDepartmentSelect = (value: string) => {
      setValue('department', value)
      if (!value) {
        setSearchDepartment('')
      }
    }

    return (
      <SearchableInput
        searchResult={searchResult}
        onSearchChange={handleSearchChange}
        isFetching={isFetching}
        wrapperClassName="tc-mv-input-wrapper"
        placeholder="Start typing..."
        onSelect={onDepartmentSelect}
        fetchNextPage={fetchNextPage}
        needFetchNextPage={hasNextPage && !isFetchingNextPage}
        disabled={disabled}
        defaultValue={defaultValue}
      />
    )
  },
)

export { DepartmentSelect }
